var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "mask",
      on: {
        mousedown: function ($event) {
          if ($event.target !== $event.currentTarget) return null
          return _vm.onClose.apply(null, arguments)
        },
      },
    },
    [
      _c("div", { staticClass: "rename-dialog" }, [
        _c("div", { staticClass: "rename-header" }, [
          _c("span", { staticClass: "rename-header-title" }, [
            _vm._v(_vm._s(_vm.$t("homePage.novelList.grouping.renameTitle"))),
          ]),
          _c(
            "button",
            { staticClass: "rename-close-button", on: { click: _vm.onClose } },
            [_c("IconClose", { staticClass: "rename-close-icon" })],
            1
          ),
        ]),
        _c("div", { staticClass: "rename-body" }, [
          _c("div", { staticClass: "rename-label-row" }, [
            _c("span", { staticClass: "rename-label" }, [
              _vm._v(_vm._s(_vm.$t("homePage.novelList.grouping.groupName"))),
            ]),
            _c(
              "span",
              {
                staticClass: "rename-char-count",
                class: { over: _vm.isOverLimit },
              },
              [_vm._v(_vm._s(_vm.charCount) + "/50")]
            ),
          ]),
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.groupName,
                expression: "groupName",
              },
            ],
            staticClass: "rename-input",
            attrs: {
              type: "text",
              placeholder: _vm.$t(
                "homePage.novelList.grouping.groupNamePlaceholder"
              ),
              maxlength: _vm.GROUP_NAME_MAX_LENGTH,
            },
            domProps: { value: _vm.groupName },
            on: {
              input: function ($event) {
                if ($event.target.composing) return
                _vm.groupName = $event.target.value
              },
            },
          }),
        ]),
        _c("div", { staticClass: "rename-actions" }, [
          _c(
            "button",
            {
              staticClass: "rename-submit-button",
              attrs: { disabled: !_vm.canSubmit },
              on: { click: _vm.onSubmit },
            },
            [
              _vm._v(
                " " + _vm._s(_vm.$t("homePage.novelList.grouping.update")) + " "
              ),
            ]
          ),
          _c(
            "button",
            { staticClass: "rename-cancel-button", on: { click: _vm.onClose } },
            [_vm._v(" " + _vm._s(_vm.$t("common.close")) + " ")]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }